import type { IxcRegistrationV1AccountKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const REGISTRATION_ACCOUNT_BASE_PATH = getResolvedPath('/registration/account');

export const getRegistrationAccountPath: EntityPathBuilder<IxcRegistrationV1AccountKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return REGISTRATION_ACCOUNT_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.accountId) {
        return undefined;
      }

      return getResolvedPath(`${REGISTRATION_ACCOUNT_BASE_PATH}/$accountId`, context?.keys);
    }
  }
};

export function getRegistrationAccountDetailPath<T extends string | undefined>(accountId: T): T extends string ? string : undefined {
  if (!accountId) {
    return undefined as any;
  }

  return getRegistrationAccountPath({ kind: 'detail', keys: { accountId } }) as any;
}
